import { render, staticRenderFns } from "./UcRegisterEntryMiniCard.yaml?vue&type=template&id=622b5ce4&component"
import script from "./UcRegisterEntryMiniCard.yaml?vue&type=script&lang=ts&component"
export * from "./UcRegisterEntryMiniCard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports